import EditSubscription from "@/components/server/EditSuscription/EditSubscription";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/user/subscription/edit")({
  component: EditSubscription,
  beforeLoad: () => {
    document.title = "Maifud - Editar suscripción";
  },
});
